/* eslint-disable no-underscore-dangle */
import lod_ from "lodash";
import { Drawer, Icon, IconButton } from "@mui/material";
import { useEffect, useState } from "react";
import FormAction from "redux-react/actions/formAction";
import { useDispatch, useSelector } from "react-redux";
import MDBox from "components/Basics/MDBox";
import MDTypography from "components/Basics/MDTypography";
import { selectCurrentProfile } from "redux-react/reducers/profileReducer";
import { DateTime } from "luxon";

const drawerStyles = {
	"& .MuiDrawer-paper": {
		width: { xs: "100%", sm: "40%" },
		p: 2,
		height: "100%",
		display: "flex",
		flexDirection: "column",
		overflow: "hidden",
		margin: 0,
		boxSizing: "border-box",
		backgroundColor: "#fff",
		borderRadius: { xs: 0, sm: "8px 0 0 8px" },
		maxWidth: "100vw"
	}
};

const MessageList = ({ open, onClose, action, values }) => {
	const dispatch = useDispatch();
	const profile = useSelector(selectCurrentProfile);
	const [conversation, setConversation] = useState({});
	const [graph, setGraph] = useState({});

	const getGraph = async code => {
		dispatch(
			FormAction.getItemsFromCollection(
				"llmGraph",
				{
					query: {
						code,
						active: { $in: [null, true] },
						assistantID: profile.assistantID
					},

					projection: {
						name: 1
					}
				},
				res => {
					const item = res.items[0];
					setGraph(item ?? {});
				}
			)
		);
	};

	const getConversation = async id => {
		let queryConversation = await new Promise(resolve => {
			dispatch(
				FormAction.getItemsFromCollection(
					"thread",
					{
						query: {
							_id: id,
							active: null,
							assistantID: null
						}
					},
					res => {
						const item = res.items[0];
						resolve(item);
					}
				)
			);
		});

		if (lod_.isNil(queryConversation)) {
			return;
		}

		// Set conversation
		setConversation(queryConversation);

		// Graph
		if (!lod_.isNil(queryConversation.graph)) {
			await getGraph(queryConversation.graph);
		}
	};

	useEffect(() => {
		if (open === true) {
			const id = values?._id;
			if (!lod_.isNil(id)) {
				getConversation(id);
			}
		} else {
			setConversation({});
		}
	}, [values, open]);

	return (
		<Drawer open={open} onClose={onClose} anchor="right" sx={drawerStyles}>
			{/* Header */}
			<MDBox display="flex" alignItems="center" justifyContent="space-between" mb={2}>
				<MDBox>
					<MDTypography variant="h6">{graph.name ?? conversation.graph ?? ""}</MDTypography>
					<MDTypography variant="body2" fontSize="small">
						{DateTime.fromISO(conversation.header?.createdAt)
							.setLocale("fr")
							.toLocaleString(DateTime.DATETIME_MED)}
					</MDTypography>
				</MDBox>
				<MDBox>
					<IconButton onClick={onClose}>
						<Icon>close</Icon>
					</IconButton>
				</MDBox>
			</MDBox>
			{/* Content */}
			{!lod_.isEmpty(conversation) && <ConversationBox conversation={conversation} />}
			{lod_.isEmpty(conversation) && <>Chargement</>}
		</Drawer>
	);
};

/**
 * Message component
 * @param {Object} props - The component props
 * @param {Object} props.message - The message object containing text and direction
 * @returns {JSX.Element} The rendered message box
 */
const Message = ({ message }) => {
	let styleDirection = {
		whiteSpace: "pre-wrap"
	};

	let { direction, text } = message;

	if (direction === "bot") {
		styleDirection = {
			...styleDirection,
			left: 10,
			maxWidth: "80%",
			marginRight: "20%",
			backgroundColor: "white",
			color: "#344767",
			fontWeight: "normal",
			borderRadius: "15px 15px 15px 0",
			padding: 10
		};
	} else if (direction === "contact") {
		styleDirection = {
			...styleDirection,
			right: 10,
			maxWidth: "80%",
			marginLeft: "20%",
			backgroundColor: "#2196f3",
			color: "white",
			fontWeight: "bold",
			borderRadius: "15px 15px 0 15px",
			padding: 10
		};
	}

	return (
		<MDBox mt={1} style={styleDirection}>
			<p
				style={{
					fontSize: 12
				}}
				// eslint-disable-next-line react/no-danger
				dangerouslySetInnerHTML={{ __html: text }}
			></p>
		</MDBox>
	);
};

/**
 * Conversation component
 * @param {Object} props - The component props
 * @param {Object} props.conversation - The conversation object containing messages
 * @returns {JSX.Element} The rendered conversation box
 */
const ConversationBox = ({ conversation }) => {
	return (
		<MDBox
			style={{
				height: "100%",
				overflowY: "auto"
			}}
			display="flex"
			flexDirection="column"
		>
			<MDBox
				p={1}
				flex="1"
				borderRadius="md"
				style={{
					position: "relative",
					backgroundColor: "rgb(236 236 236)",
					overflowY: "auto",
					height: "100%"
				}}
			>
				{conversation.messages.map((message, index) => (
					<Message message={{ text: message.payload.content, direction: message.header.source }} />
				))}
			</MDBox>
		</MDBox>
	);
};

export default MessageList;
